module.exports = __webpack_public_path__ + "static/ba-f50edabda46340bd4c299edb247da1a3.png";